import React from 'react'
import './services.css'
import { FaCheck } from 'react-icons/fa'

const Services = () => {
    return (
        <section id='services'>
            <h5>What I Offer</h5>
            <h2>Services</h2>

            <div className="container services__container">

                {/* Software Engineering */}
                <article className="service">
                    <div className="service__head">
                        <h3>Software Engineering</h3>
                    </div>
                    <ul className='service__list'>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>End-to-end development of scalable, secure, and high-performance applications.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Expertise in full-stack development (Java, Spring, Angular, React).</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Designing distributed systems and cloud-native architectures.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Strong database design & engineering with Oracle/PostgreSQL/MySQL.</p>
                        </li>
                    </ul>
                </article>

                {/* Data-Driven Strategy */}
                <article className="service">
                    <div className="service__head">
                        <h3>Data-Driven Strategy</h3>
                    </div>
                    <ul className='service__list'>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Transforming raw data into actionable insights through analysis & visualization.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Developing dashboards and reports for smarter decision-making.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Advising on IT strategies that align technology with business goals.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Bridging technical expertise with strategic planning for growth.</p>
                        </li>
                    </ul>
                </article>

                {/* Cloud & DevOps Engineering */}
                <article className="service">
                    <div className="service__head">
                        <h3>Cloud & DevOps Engineering</h3>
                    </div>
                    <ul className='service__list'>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Building cloud infrastructure on AWS, Azure, and GCP.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Implementing CI/CD pipelines with Jenkins, Maven, and GitHub Actions.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Containerization and orchestration with Docker & Kubernetes.</p>
                        </li>
                        <li>
                            <FaCheck className='service__list-icon'/>
                            <p>Ensuring scalability, security, and reliability through DevOps best practices.</p>
                        </li>
                    </ul>
                </article>

            </div>
        </section>
    )
}

export default Services
